'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect, useState } from 'react'
import { WebviewTenant } from '@enums/webview-tenant'
import { genericWebviewHandler, WebViewActions } from '@utils/client/webview'
import { TenantActionValue } from '@configs/webview-tenant-config'
import Cookies from 'js-cookie'

interface IWebviewParams {
  tenant?: WebviewTenant
  tenantPage?: string
}

export const WebviewInitializer = ({ tenant = WebviewTenant.ACKODRIVE }: IWebviewParams) => {
  const [nativeHeaderHeight] = useState<number>(64)
  useEffect(() => {
    const initializeWebview = () => {
      genericWebviewHandler({
        action: WebViewActions.UPDATE_APP_BAR,
        actionValue: TenantActionValue[tenant],
      })
    }
    initializeWebview()
  }, [])
  if (!Cookies.get('native_header_height')) return null
  return <div style={{ height: `${nativeHeaderHeight}px` }}></div>
}
